export function typewriter(node) {
  let requestId;
  let index = 0;
  let lines = Array.from(node.children).filter((d) => d.nodeName !== "BR");
  let startTime = 0;

  let showLine = (timestamp) => {
    if (startTime === 0) {
      startTime = timestamp;
    }

    const elapsedTime = timestamp - startTime;

    lines[index].classList.add("active-line");
    lines[index].classList.remove("invisible");

    if (index > 0) {
      lines[index - 1].classList.remove("active-line");
    }

    if (elapsedTime > 100) {
      startTime = 0;
      index += 1;
    }

    if (index < lines.length) {
      requestId = window.requestAnimationFrame(showLine);
    }
  };

  window.requestAnimationFrame(showLine);

  return {
    destroy() {
      cancelAnimationFrame(requestId);
    },
  };
}
